// extracted by mini-css-extract-plugin
export default {"rootContainer":"MatissePortalSideMenu_rootContainer__Ou1GV","sideMenu":"MatissePortalSideMenu_sideMenu__jvvtq"};